<template>
  <div>

    <div
      class="box box-info"
      v-if="areFilters"
    >
      <div
        class="box-header with-border"
        v-if="!showFilters"
      >
        <slot name="filtersDescription"></slot>
        <div class="box-tools pull-right">
          <a
            href="#"
            @click.prevent="showFilters = true"
          >[Cambiar]</a>
        </div>
      </div>

      <div
        class="box-header with-border"
        v-if="showFilters"
      >
        <h3 class="box-title">Filtrar</h3>

        <div class="box-tools pull-right">
          <button
            type="button"
            class="btn btn-box-tool"
            @click="showFilters = false"
            data-original-title="Cancelar"
          >
            <i class="fa fa-times"></i></button>
        </div>
        <div class="box-body">
          <el-form
            :inline="true"
            ref="filters"
            :model="filters"
            class="demo-form-inline"
          >
            <el-row>
              <el-col :span="24">
                <slot
                  name="filtersForm"
                  :filters="filters"
                ></slot>
              </el-col>
            </el-row>
            <el-row>
              <el-col
                :span="24"
                style="text-align: right;"
              >
                <el-form-item
                  v-if="Object.keys(filters).length"
                  style="margin-bottom: 0;"
                >
                  <el-button
                    type="primary"
                    @click="handleFilter"
                  >Filtrar</el-button>
                </el-form-item>
                <el-form-item
                  v-if="Object.keys(filters).length"
                  style="margin-bottom: 0;"
                >
                  <el-button
                    type="info"
                    @click="handleClearFilters"
                  >Limpiar</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>

    <div class="box-tools pull-left">
      <slot name="tableActions"></slot>
    </div>
    <div
      class="box-tools pull-left"
      v-if="showChecks"
    >
      <span>Sel. {{checkedIds.length}}</span>
      <slot
        name="selectedActions"
        :checkedIds="checkedIds"
      ></slot>
    </div>
    <div class="box-tools pull-right">
      <el-pagination
        v-if="pagination.total != null"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.per_page"
        layout="total, prev, pager, next"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
    <el-table
      ref="dataTable"
      v-loading="loading"
      :data="data"
      max-height="500"
      stripe
      highlight-current-row
      @select-all="handleSelectAll"
      @select="handleSelect"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >
      <slot
        name="columns"
        :header="header"
      ></slot>
    </el-table>
    <div class="box-tools pull-right">
      <el-pagination
        v-if="pagination.total != null"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.per_page"
        layout="total, prev, pager, next"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<style>
.el-table td {
  padding: 0;
}
</style>


<script type="text/javascript">
export default {
  name: 'el-data-table',
  props: {
    showChecks: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    resourceUrl: String,
    config: {
      type: Object,
      default: function () {
        return {};
      }
    },
    filters: {
      type: Object,
      default: function () {
        return {};
      }
    },
    externalFiltersValid: {
      type: Boolean,
      default: function () {
        return null;
      }
    }
  },
  data: function () {
    let areFilters = Object.keys(this.filters).length > 0;
    let showFilters = areFilters;
    return {
      showFilters,
      data: [],
      header: [],
      checkedIds: [],
      pagination: {
        current_page: null,
        from: null,
        last_page: null,
        next_page_url: null,
        per_page: null,
        prev_page_url: null,
        to: null,
        total: null
      },
      fullPath: null,
      dataLoaded: true,
      areFilters,
      loading: false
    }
  },
  watch: {
    '$route': function (to) {
      // console.log(to);
      if (to.path == this.resourceUrl) {
        // this.fullPath = to.fullPath;
        // if (this.fullPath != this.resourceUrl + '?' + $.param(to.query)) {
        // console.log('watch route');
        this.fullPath = this.resourceUrl + '?' + $.param(to.query);
        this.fillFiltersForm();
        if (this.externalFiltersValid == null || this.externalFiltersValid) {
          this.fetchItems();
        }
        // }
      }
    },
    'externalFiltersValid': function (to) {
      if (to) {
        this.fetchItems();
      }
    }
  },
  mounted: function () {
    // console.log(this.$route);
    this.fullPath = this.resourceUrl + '?' + $.param(this.$route.query);
    if (this.externalFiltersValid == null || this.externalFiltersValid) {
      this.fillFiltersForm();
      // return;
      this.$emit('filtersSubmited', this.filters);
      this.fetchItems();
    }
  },
  methods: {
    fetchItems: function () {
      // console.log(this.fullPath);
      // if (!this.filtersValid) return;
      // console.log(this.showFilters);
      // console.log(Object.keys(this.$route.query).length);
      if (this.showFilters) {
        this.$refs['filters'].validate((valid) => {
          if (valid) {
            this.blindFetch();
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
        // } else if (Object.keys(this.$route.query).length > 0) {
      } else {
        // console.log('blindFetch');
        this.blindFetch();
      }
    },
    blindFetch: function () {
      this.dataLoaded = false;
      this.showFilters = false;
      this.loading = true;
      axios.get('/api' + this.fullPath).then((response) => {
        // axios.get('/api' + this.resourceUrl).then((response) => {
        // console.log(response.data);
        this.data = response.data.data;
        this.header = response.data.header || [];
        this.pagination.current_page = response.data.current_page;
        this.pagination.from = response.data.from;
        this.pagination.last_page = response.data.last_page;
        this.pagination.next_page_url = response.data.next_page_url;
        this.pagination.per_page = response.data.per_page;
        this.pagination.prev_page_url = response.data.prev_page_url;
        this.pagination.to = response.data.to;
        this.pagination.total = response.data.total;
        this.dataLoaded = true;

        Vue.nextTick(() => { this.checkSelectedRows() });
        this.$emit('itemsFetched', true);
        // console.log('emit itemsFetched');
        this.loading = false;
      });
    },
    fillFiltersForm: function () {
      _.each(this.filters, (value, key) => {
        // console.log(key);
        // console.log(this.$route.query[key]);
        if (this.$route.query[key] != undefined && this.$route.query[key] != null) {
          if ((key == 'functional_area_id' || key == 'roster_id' || key == 'labor_agreement_id') && (!this.config.selectFiltersAreAtomic || false) && !Array.isArray(this.$route.query[key])) {
            this.filters[key] = [this.$route.query[key]];
          } else {
            this.filters[key] = this.$route.query[key];
          }
        } else {
          // _.each(this.filters, (elem, idx) => {
          // 	if (elem.id == key && elem.mandatory)
          // 		this.filtersValid = false;
          // });
          this.filters[key] = this.filters[key] || null;
        }
      });
    },
    handleFilter: function () {
      this.$refs['filters'].validate((valid) => {
        if (valid) {
          let query = { page: 1 };
          // let transform = this.filtersTransform(this.filters);
          _.each(this.filters, (value, key) => {
            // console.log(key);
            // console.log(value);
            if (value != null && key != 'date_range') {
              // query[key] = (Array.isArray(value)) ? value.join('^') : value; //this.filters[key];
              query[key] = value; //this.filters[key];
            }
          });
          // console.log(query);
          this.showFilters = false;
          this.$router.push({ path: this.resourceUrl, query });
          this.$emit('filtersSubmited', this.filters);
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleClearFilters: function () {
      this.data = [];
      this.pagination = {
        current_page: null,
        from: null,
        last_page: null,
        next_page_url: null,
        per_page: null,
        prev_page_url: null,
        to: null,
        total: null
      };
      let query = { page: 1 };
      _.each(this.filters, (value, key) => {
        this.filters[key] = null;
      });
      // console.log(query);
      this.$router.push({ path: this.resourceUrl, query });
    },
    handleCurrentChange: function (page) {
      let query = (JSON.parse(JSON.stringify(this.$route.query)));
      // console.log(query);
      // console.log(this.config);
      // if (this.config != undefined && this.config.level != undefined) {
      // 	query[this.config.level + '_page'] = page;
      // 	query['level'] = this.config.level;
      // } else {
      query['page'] = page;
      // }

      this.$router.push({ path: this.resourceUrl, query: query });
    },
    handleSizeChange: function (page) {
    },
    handleSelectionChange(value) {
      this.$emit('selectionChanged', value);
    },
    handleSortChange(value) {
      this.$emit('sortChanged', value);
    },
    handleSelectAll(selection) {
      // console.log(value);
      let checkedIds = [...this.checkedIds];
      if (selection.length > 0) {
        _.each(selection, (row) => {
          if (!checkedIds.includes(row.id)) {
            checkedIds.push(row.id);
          }
        });
      } else {
        _.each(this.data, (row) => {
          checkedIds.splice(checkedIds.indexOf(row.id), 1);
        });
      }
      this.checkedIds = checkedIds;
    },
    handleSelect(selection, row) {
      let adding = false;

      for (let i in selection) {
        if (selection[i].id == row.id) {
          adding = true;
          break;
        }
      }

      if (adding) {
        this.checkedIds.push(row.id);
      } else {
        this.checkedIds.splice(this.checkedIds.indexOf(row.id), 1);
      }
    },
    checkSelectedRows() {
      if (this.checkedIds.length > 0) {
        // console.log(this.checkedIds);
        this.data.forEach((row) => {
          if (this.checkedIds.includes(row.id)) {
            // console.log(row.id);
            this.$refs['dataTable'].toggleRowSelection(row, 'selected');
          }
        });
      }
    },
    clearSelection() {
      if (this.checkedIds.length > 0) {
        this.data.forEach((row) => {
          if (this.checkedIds.includes(row.id)) {
            // console.log(row.id);
            this.$refs['dataTable'].toggleRowSelection(row, '');
          }
        });
        this.checkedIds = [];
      }
    }
  }
}
</script>